import { ORDER_SET_LIST } from './actionTypes'

export default function orderSetList(payload) {
  return {
    type: ORDER_SET_LIST,
    payload,
  }
}
